import React from 'react'

import type {AllPageProps} from 'types/PageProps'

export const PagePropsContext = React.createContext<AllPageProps>(undefined)

/**
 * @deprecated - this is not intended for public use and may change in the future.
 */
export const usePageProps = () => {
  const pageProps = React.useContext(PagePropsContext)
  if (!pageProps) {
    throw new Error('usePageProps must be used within a PagePropsProvider')
  }
  return pageProps
}
